module.exports = __webpack_public_path__ + "static/media/aktAnnons.c75099ee.png";